module.exports = __webpack_public_path__ + "images/125_160.jpg";